import * as colors from "../styles/colors";
import * as docketPropTypes from "../docketPropTypes";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import XIcon from "./icons/XIcon";
import { StyleSheet, css } from "aphrodite/no-important";

const styles = StyleSheet.create({
	closeIcon: {
		padding: 5,
		fill: colors.textGrey,
		width: 24,
		height: 24,
	},
});

export default class StyledXIcon extends PureComponent {
	static propTypes = {
		aStyles: docketPropTypes.aphroditeStyles,
		style: PropTypes.object,
	};

	render() {
		return (
			<XIcon className={css(styles.closeIcon, this.props.aStyles)} style={this.props.style} />
		);
	}
}
